import React from 'react';
import { TicketDetail } from '../../types';
import { requestform } from '../../messages';
import CheckPermissionButton from './CheckPermissionButton';
import { Dropdown } from 'antd';
import { PERMISSION } from '../../utils';
import { useLocation } from 'react-router-dom';
import { useProfile } from '../../hooks';

type ControllerActionButtonProps = {
  requestItem: TicketDetail;
  status: string;
  isHistory?: boolean;

  receptionTicketAction: () => void;
  inprocessTicketAction: () => void;
  completeCollaborationTicket: () => void;
  completeTicketAction: () => void;
  updateObstacleTicket: () => void;
  completeObstacleTicket: () => void;

  open: boolean;
  setIsModal: (open: boolean) => void;
  setOpen: (open: boolean) => void;

  setIsOpenObstacleModal: (open: boolean) => void;

  setIsOpenTransferModal: (open: boolean) => void;

  setIsAssignEmployeeModal: (open: boolean) => void;

  setIsProcessingRoomTransfer: (isProcessing: boolean) => void;
  setIsTransferCenterModal: (isOpenTransferModal: boolean) => void;

  setModalTransferOrganization: (isOpen: boolean) => void;

  setModalTransferAppCT: (isOpen: boolean) => void;
};

const ControllerActionButton: React.FC<ControllerActionButtonProps> = ({
  requestItem,
  status,
  open,
  isHistory = false,

  receptionTicketAction,
  inprocessTicketAction,
  completeCollaborationTicket,
  completeTicketAction,
  updateObstacleTicket,
  completeObstacleTicket,
  setIsModal,
  setOpen,
  setIsOpenObstacleModal,
  setIsOpenTransferModal,
  setIsAssignEmployeeModal,
  setIsProcessingRoomTransfer,
  setIsTransferCenterModal, //Chuyển phiếu trung tâm

  setModalTransferOrganization, //Chuyển phiếu đơn vị
  setModalTransferAppCT //Chuyển phiếu cho app công trường
}) => {
  const location = useLocation();
  const { profile } = useProfile();

  const menu = {
    items: [
      {
        key: '1',
        label: (
          <CheckPermissionButton permission={PERMISSION.UPDATE_TICKET_ORG_UNIT}>
            <button
              onClick={() => setIsOpenObstacleModal(true)}
              className='w-full rounded-lg border border-[#D1131D] px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#D1131D]'
            >
              {requestform.obstacleTickets}
            </button>
          </CheckPermissionButton>
        )
      },
      {
        key: '2',
        label: (
          <CheckPermissionButton permission={PERMISSION.UPDATE_RETURN_TICKET_TO_CSKH}>
            <button
              onClick={() => setIsTransferCenterModal(true)}
              className='w-full rounded-lg border border-[#D1131D] bg-transparent px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#D1131D]'
            >
              {requestform.transferCustomerCareCenter}
            </button>
          </CheckPermissionButton>
        )
      },
      {
        key: '3',
        label: (
          <CheckPermissionButton permission={PERMISSION.TRANSFER_TICKET_TO_SUPPORT_UNIT}>
            <button
              onClick={() => {
                setModalTransferOrganization(true);
              }}
              className='w-full rounded-lg border border-[#1564E8] bg-transparent px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#1564E8]'
            >
              {requestform.transferOtherOrganization}
            </button>
          </CheckPermissionButton>
        )
      },
      {
        key: '4',
        label: (
          <CheckPermissionButton permission={PERMISSION.UPDATE_TICKET_ORG_UNIT}>
            <button
              onClick={() => {
                setIsProcessingRoomTransfer(false); // 👈 phân biệt là chuyển phối hợp
                setIsOpenTransferModal(true);
              }}
              className='w-full rounded-lg border border-[#1564E8] bg-transparent px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#1564E8]'
            >
              {requestform.transferCollaboration}
            </button>
          </CheckPermissionButton>
        )
      },
      {
        key: '5',
        label: (
          <CheckPermissionButton permission={PERMISSION.UPDATE_TICKET_ORG_UNIT}>
            <button
              onClick={() => {
                setIsProcessingRoomTransfer(true); // 👈 chuyển trạng thái sang chuyển phòng xử lý
                setIsOpenTransferModal(true);
              }}
              className='w-full rounded-lg border border-[#FF9500] bg-transparent px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#FF9500]'
            >
              {requestform.transferProcessingRoom}
            </button>
          </CheckPermissionButton>
        )
      },

      {
        key: '6',
        label: (
          <CheckPermissionButton permission={PERMISSION.UPDATE_TICKET_ORG_UNIT}>
            {profile &&
              profile?.organizationUnit?.code == 'VH' && ( // Chức năng phòng VH
                <button
                  onClick={() => {
                    setModalTransferAppCT(true);
                  }}
                  className='w-full rounded-lg border border-[#FF9500] bg-transparent px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#FF9500]'
                >
                  {requestform.transferAppCT}
                </button>
              )}
          </CheckPermissionButton>
        )
      }
    ]
  };

  return (
    <>
      {/*                        Button Detail Tickets          */}
      {location.pathname.includes('request-form') && status !== 'completed' && !isHistory && (
        <div className='flex h-[4rem] w-full items-center justify-between border-t-2 p-6 text-left'>
          <div>
            {/** Ticket Reception*/}
            {status === 'pending_reception' && (
              <button
                onClick={() => {
                  console.log(requestItem?.serviceType?.isRequiredCmis || !requestItem?.cmisRequestId);
                  if (requestItem?.serviceType?.isRequiredCmis && !requestItem?.cmisRequestId) setIsModal(true);
                  else receptionTicketAction();
                }}
                className='w-32 rounded-lg bg-[#1564E8] px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#FFFFFF]'
              >
                {requestform.acceptTicket}
              </button>
            )}
          </div>

          <div className='flex w-full justify-between'>
            {/** Update Tickets */}
            {(status === 'in_progress' || status === 'collaboration' || status === 'DANGXULY') && (
              <CheckPermissionButton permission={PERMISSION.UPDATE_TICKET_ORG_UNIT}>
                <div>
                  {/** Collaboration Tickets */}
                  {status === 'collaboration' ? (
                    <button
                      onClick={completeCollaborationTicket}
                      className='rounded-lg bg-[#D1131D] px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#FFFFFF]'
                    >
                      {requestform.completedCollaborationButton}
                    </button>
                  ) : (
                    !requestItem.cmisRequestId && (
                      <button
                        onClick={completeTicketAction}
                        className='rounded-lg bg-[#D1131D] px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#FFFFFF]'
                      >
                        {requestform.completedButton}
                      </button>
                    )
                  )}
                </div>

                {status !== 'collaboration' && (
                  <div className='flex space-x-4'>
                    {/*Thao tác khác*/}
                    <Dropdown
                      placement='top'
                      menu={menu}
                      trigger={['click']}
                      open={open}
                      onOpenChange={(flag) => setOpen(flag)}
                    >
                      <button className='rounded-lg bg-[#1564E8] px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#FFFFFF]'>
                        {requestform.otherActionTicket}
                      </button>
                    </Dropdown>
                    <CheckPermissionButton permission={PERMISSION.ASSIGN_TICKET_ORG_UNIT}>
                      <button
                        onClick={() => setIsAssignEmployeeModal(true)}
                        className='w-fit rounded-lg border border-[#FF9500] px-6 py-[10px] text-left text-[16px]/[20px] font-semibold text-[#FF9500] hover:bg-[#FF9500] hover:text-[#FFFFFF]'
                      >
                        {requestform.assignEmployee}
                      </button>
                    </CheckPermissionButton>

                    {/** Update ticket*/}
                    <button
                      onClick={inprocessTicketAction}
                      className='w-fit rounded-lg border bg-[#28A745] px-6 py-[10px] text-left text-[16px]/[20px] font-semibold text-[#FFFFFF]'
                    >
                      {requestform.inprocessTicket}
                    </button>
                  </div>
                )}
              </CheckPermissionButton>
            )}

            {/*                     Obstacle Tickets                    */}
            {status === 'obstacle' && (
              <CheckPermissionButton permission={PERMISSION.UPDATE_TICKET_ORG_UNIT}>
                <button
                  onClick={completeObstacleTicket}
                  className='rounded-lg bg-[#28A745] px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#FFFFFF]'
                >
                  {requestform.completedObstacleTicket}
                </button>
                <button
                  onClick={updateObstacleTicket}
                  className='mr-4 rounded-lg bg-[#FF9500] px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#FFFFFF]'
                >
                  {requestform.updateObstacleTicket}
                </button>
              </CheckPermissionButton>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ControllerActionButton;
